import { ComponentStyleConfig } from "@chakra-ui/react";

const CalendarControlTheme: ComponentStyleConfig = {
  baseStyle: {
    controls: {
      pb: 0,
    },
    button: {
      height: "40px",
      _hover: {
        bg: "primary.50",
      },
    },
  },
  variants: {
    "with-buttons": {
      controls: {
        p: "24px",
      },
    },
  },
};

export default CalendarControlTheme;
